export const errorAnimation = {
  v: '5.7.12',
  fr: 30,
  ip: 0,
  op: 240,
  w: 400,
  h: 400,
  nm: 'Comp 4',
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: 'Shape Layer 1',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
        r: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0.833,
                ],
                y: [
                  0.833,
                ],
              },
              o: {
                x: [
                  0.167,
                ],
                y: [
                  0.167,
                ],
              },
              t: 36,
              s: [
                25,
              ],
            },
            {
              i: {
                x: [
                  0.34,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.167,
                ],
                y: [
                  0,
                ],
              },
              t: 37,
              s: [
                0,
              ],
            },
            {
              i: {
                x: [
                  0.833,
                ],
                y: [
                  0.833,
                ],
              },
              o: {
                x: [
                  1,
                ],
                y: [
                  0,
                ],
              },
              t: 199,
              s: [
                0,
              ],
            },
            {
              t: 240,
              s: [
                90,
              ],
            },
          ],
          ix: 10,
        },
        p: {
          a: 0,
          k: [
            200,
            200,
            0,
          ],
          ix: 2,
          l: 2,
        },
        a: {
          a: 0,
          k: [
            0,
            -50,
            0,
          ],
          ix: 1,
          l: 2,
        },
        s: {
          a: 0,
          k: [
            100,
            100,
            100,
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -1,
                      -128,
                    ],
                    [
                      -1,
                      128,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
                x: 'var $bm_rt;\n$bm_rt = createPath([\n    [\n        0,\n        100\n    ],\n    [\n        0,\n        30\n    ]\n], [], [], false);',
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'st',
              c: {
                a: 0,
                k: [
                  1,
                  1,
                  1,
                  1,
                ],
                ix: 3,
              },
              o: {
                a: 0,
                k: 100,
                ix: 4,
              },
              w: {
                a: 0,
                k: 70,
                ix: 5,
              },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Shape 2',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -1,
                      -128,
                    ],
                    [
                      -1,
                      128,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
                x: 'var $bm_rt;\n$bm_rt = createPath([\n    [\n        0,\n        0\n    ],\n    [\n        0,\n        -200\n    ]\n], [], [], false);',
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'st',
              c: {
                a: 0,
                k: [
                  1,
                  1,
                  1,
                  1,
                ],
                ix: 3,
              },
              o: {
                a: 0,
                k: 100,
                ix: 4,
              },
              w: {
                a: 0,
                k: 70,
                ix: 5,
              },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Shape 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'tm',
          s: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833,
                  ],
                  y: [
                    0.833,
                  ],
                },
                o: {
                  x: [
                    0.167,
                  ],
                  y: [
                    0.167,
                  ],
                },
                t: 36,
                s: [
                  100,
                ],
              },
              {
                i: {
                  x: [
                    0.34,
                  ],
                  y: [
                    1,
                  ],
                },
                o: {
                  x: [
                    0.167,
                  ],
                  y: [
                    0,
                  ],
                },
                t: 37,
                s: [
                  0,
                ],
              },
              {
                i: {
                  x: [
                    0.833,
                  ],
                  y: [
                    0.833,
                  ],
                },
                o: {
                  x: [
                    0.78,
                  ],
                  y: [
                    0,
                  ],
                },
                t: 209,
                s: [
                  0,
                ],
              },
              {
                t: 240,
                s: [
                  100,
                ],
              },
            ],
            ix: 1,
          },
          e: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833,
                  ],
                  y: [
                    0.833,
                  ],
                },
                o: {
                  x: [
                    0.167,
                  ],
                  y: [
                    0.167,
                  ],
                },
                t: 36,
                s: [
                  100,
                ],
              },
              {
                i: {
                  x: [
                    0.833,
                  ],
                  y: [
                    0.833,
                  ],
                },
                o: {
                  x: [
                    0.167,
                  ],
                  y: [
                    0.167,
                  ],
                },
                t: 37,
                s: [
                  0,
                ],
              },
              {
                i: {
                  x: [
                    0.34,
                  ],
                  y: [
                    1,
                  ],
                },
                o: {
                  x: [
                    0.167,
                  ],
                  y: [
                    0.167,
                  ],
                },
                t: 43,
                s: [
                  0,
                ],
              },
              {
                t: 60,
                s: [
                  100,
                ],
              },
            ],
            ix: 2,
          },
          o: {
            a: 0,
            k: 0,
            ix: 3,
          },
          m: 2,
          ix: 3,
          nm: 'Trim Paths 1',
          mn: 'ADBE Vector Filter - Trim',
          hd: false,
        },
      ],
      ip: 0,
      op: 240,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: 'main',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
        r: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.167,
                ],
                y: [
                  0.167,
                ],
              },
              t: 0,
              s: [
                -90,
              ],
            },
            {
              t: 45,
              s: [
                90,
              ],
            },
          ],
          ix: 10,
        },
        p: {
          a: 0,
          k: [
            200,
            200,
            0,
          ],
          ix: 2,
          l: 2,
        },
        a: {
          a: 0,
          k: [
            0,
            0,
            0,
          ],
          ix: 1,
          l: 2,
        },
        s: {
          a: 0,
          k: [
            100,
            100,
            100,
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ef: [
        {
          ty: 5,
          nm: 'Slider Control',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0,
                      ],
                      y: [
                        1,
                      ],
                    },
                    o: {
                      x: [
                        0.167,
                      ],
                      y: [
                        0.167,
                      ],
                    },
                    t: 0,
                    s: [
                      0,
                    ],
                  },
                  {
                    i: {
                      x: [
                        0.744,
                      ],
                      y: [
                        1,
                      ],
                    },
                    o: {
                      x: [
                        0.421,
                      ],
                      y: [
                        0,
                      ],
                    },
                    t: 30,
                    s: [
                      150,
                    ],
                  },
                  {
                    i: {
                      x: [
                        0.833,
                      ],
                      y: [
                        0.833,
                      ],
                    },
                    o: {
                      x: [
                        0.552,
                      ],
                      y: [
                        0,
                      ],
                    },
                    t: 35,
                    s: [
                      150,
                    ],
                  },
                  {
                    t: 45,
                    s: [
                      0,
                    ],
                  },
                ],
                ix: 1,
              },
            },
          ],
        },
      ],
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -112.5,
                      -13,
                    ],
                    [
                      57,
                      -13,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
                x: "var $bm_rt;\nvar a;\na = effect('Slider Control')('Slider');\n$bm_rt = createPath([\n    [\n        $bm_neg(a),\n        0\n    ],\n    [\n        a,\n        0\n    ]\n], [], [], false);",
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 45,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Shape 2',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -112.5,
                      -13,
                    ],
                    [
                      57,
                      -13,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
                x: "var $bm_rt;\nvar a;\na = effect('Slider Control')('Slider');\n$bm_rt = createPath([\n    [\n        $bm_neg(a),\n        0\n    ],\n    [\n        a,\n        0\n    ]\n], [], [], false);",
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: -45,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Shape 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'st',
          c: {
            a: 0,
            k: [
              1,
              1,
              1,
              1,
            ],
            ix: 3,
          },
          o: {
            a: 0,
            k: 100,
            ix: 4,
          },
          w: {
            a: 0,
            k: 45,
            ix: 5,
          },
          lc: 1,
          lj: 1,
          ml: 4,
          bm: 0,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false,
        },
      ],
      ip: 0,
      op: 240,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
};
